/* /balayage - converted from a blog post into a service page.

   The URL is unchanged on purpose: it already had 256 impressions at position
   15.7 as an article, and a redirect would throw that away. What changed is
   the intent - copy, title, og:type ('article' → 'website') and the schema
   (BlogPosting out, Service in; see src/seo/head.mjs).

   It still appears on /blog, so the existing internal link keeps working, and
   it is now also in the Services menu where a service page belongs. */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Bredcrumb from '../../HomeMain/Bredcrumb';
import Appointment from '../../HomeMain/Appointment';
import Faq from '../../ui/Faq';
import {
  Section, Heading, P, FeatureList, PriceTable, PriceList, buttonStyle, BRAND, INK, sans,
} from '../../ui/blocks';
import { HAIR } from '../../../config/prices.mjs';
import { linkTo } from '../../../i18n/lang.mjs';

const TREATMENTS = '/tretmani-kose';
const COLOURING = '/farbanje-kose';

const Main = () => {
  const { t, i18n } = useTranslation();
  const lang = ['sr', 'en', 'de'].includes(i18n.language) ? i18n.language : 'sr';

  const techniques = t('balayagePage.techniques.items', { returnObjects: true });
  const faq = t('balayagePage.faq.items', { returnObjects: true });

  /* Labels are translated, amounts come from src/config/prices.mjs - the same
     source the /pricing table and the Service JSON-LD read, so the three can
     never disagree. Rendered as text in a real table, never as an image. */
  const priceRows = t('balayagePage.pricing.rows', { returnObjects: true })
    .map((label, i) => ({ label, price: HAIR.balayage[i] }));

  const linkStyle = {
    display: 'inline-block',
    marginTop: '6px',
    fontFamily: sans,
    fontSize: '15px',
    fontWeight: 600,
    color: BRAND,
  };

  return (
    <>
      <Bredcrumb title={t('pages.balayage.title')} subtitle={t('pages.balayage.subtitle')} />

      <Section>
        <P style={{ fontSize: '18px', color: INK, fontWeight: 500 }}>{t('balayagePage.intro.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('balayagePage.intro.p2')}</P>
      </Section>

      <Section tinted>
        <Heading>{t('balayagePage.techniques.heading')}</Heading>
        <FeatureList items={techniques} />
        <P style={{ marginTop: '20px', marginBottom: 0 }}>{t('balayagePage.techniques.note')}</P>
      </Section>

      <PriceList
        title={t('balayagePage.pricing.heading')}
        footnote={t('balayagePage.pricing.note2')}
      >
        <PriceTable rows={priceRows} note={t('balayagePage.pricing.note1')} />
      </PriceList>

      <Section tinted>
        <Heading>{t('balayagePage.duration.heading')}</Heading>
        <P>{t('balayagePage.duration.p1')}</P>
        <P style={{ marginBottom: 0 }}>{t('balayagePage.duration.p2')}</P>
      </Section>

      <Section>
        <Heading>{t('balayagePage.aftercare.heading')}</Heading>
        <P>{t('balayagePage.aftercare.p1')}</P>
        <P>{t('balayagePage.aftercare.p2')}</P>
        <P>{t('balayagePage.aftercare.p3')}</P>
        <Link to={linkTo(TREATMENTS, lang)} style={linkStyle}>
          {t('balayagePage.aftercare.treatmentsLink')} →
        </Link>
        <br />
        <Link to={linkTo(COLOURING, lang)} style={linkStyle}>
          {t('balayagePage.colouringLink')} →
        </Link>
      </Section>

      <Section tinted>
        <Heading align="center">{t('balayagePage.faq.heading')}</Heading>
        <Faq items={faq} />
      </Section>

      {/* Same booking form as /contact, pre-filled with this page's service. */}
      <Appointment defaultService="Balayage" />


      <Section>
        <div style={{ textAlign: 'center' }}>
          <Link to="/hairdresser" style={buttonStyle('outline')}>
            {t('hairdresserService.breadcrumbTitle')}
          </Link>
        </div>
      </Section>
    </>
  );
};

export default Main;
